import { useCallback, useEffect, useState } from "react";

interface UseApiResult<T> {
  isFetched: boolean;
  loading: boolean;
  data: T;
  // eslint-disable-next-line
  setData: (val: T | Function) => void;
  refresh: () => void;
}

export function useApi<T>(
  // eslint-disable-next-line
  apiCall?: Function,
  depList: unknown[] = [],
  dataMutator?: (v: unknown) => void
): UseApiResult<T> {
  const [isFetched, setFetched] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<T | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);

    const { success, data } = await apiCall();
    const newData = success && dataMutator ? dataMutator(data) : success ? data : null;

    setData(newData);
    setLoading(false);
    setFetched(true);
  }, [apiCall, dataMutator]);

  useEffect(() => {
    if (apiCall) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...depList]);

  return {
    isFetched,
    loading,
    data,
    setData,
    refresh: fetchData,
  };
}
